if (!customElements.get('module-seven')) {
  class ModuleSeven extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.slider = this.querySelector('.module-seven--contentContent');

      const flkty = new Flickity( this.slider, {
        cellAlign: 'left',
        contain: true,
        pageDots: false
      });
    }
  }
  customElements.define('module-seven', ModuleSeven);
}